import React, { FocusEvent, useCallback, useEffect, useState } from 'react'
import { OptionProp } from '../OptionSelector.constant'
import classnames from 'classnames'
import { DEFAULT_CUSTOMIZATION_CHAR } from '../../../organisms/productPageSections/productImages/productImages.helper'
import styles from './inputOption.module.scss'

const DEPRECATED_InputOption = ({ onChange }: Pick<OptionProp, 'onChange'>) => {
  const [ipValue, setIpValue] = useState(DEFAULT_CUSTOMIZATION_CHAR)
  const [prevValue, setPrevValue] = useState('')
  const handleOnblur = (e: FocusEvent<HTMLInputElement>) => {
    if (!e.target.value) {
      setIpValue(prevValue)
      if (onChange) {
        onChange(prevValue)
      }
    }
  }
  /**
   *1. Direct input change - fills the alphabet if valid, shows empty value otherwise
    2. Backspace is allowed and deletes the input
    3. Onblur - fills the prev value in the input
   */
  const handleChange = useCallback(
    e => {
      const value = e.target.value
      let finalValue
      if (value) {
        finalValue = value.slice(-1).toUpperCase()
        const charCode = finalValue.charCodeAt(0)
        if (charCode < 65 || charCode > 90) {
          finalValue = ''
        }
      } else {
        finalValue = ''
      }
      if (ipValue) {
        setPrevValue(ipValue)
      }
      if (finalValue && onChange) {
        onChange(finalValue)
      }
      setIpValue(finalValue)
    },
    [ipValue],
  )
  useEffect(() => {
    setTimeout(() => {
      if (onChange) {
        onChange(DEFAULT_CUSTOMIZATION_CHAR)
      }
    }, 500) // Using timeout here to set initial state so that other state changes don't override this one
  }, [])
  return (
    <input
      className={classnames(styles.deprecatedOption)}
      onChange={e => {
        handleChange(e)
      }}
      value={ipValue}
      onBlur={handleOnblur}
    />
  )
}

export default DEPRECATED_InputOption
